import React from "react";
import { NavLink } from "react-router-dom";

import logo from "../../assets/img/logo.png";
import "./styles.css";

const AppFooter = () => (
    <footer className="app-footer">
        <small>
            © Copyright 2025 conectado.claro.com.br - Todos os direitos reservados
        </small>
        <NavLink
            to="/app"
            className="app-footer__home-link"
            aria-label="Ir para a tela inicial"
            title="Tela inicial"
        >
            <img className="app-footer__logo" src={logo} alt="Conectado" />
        </NavLink>
    </footer>
);

export default AppFooter;
